/**
 * @desc directives统一导出，导入文件
 * @todo 默认内置directives
 */
import Vue from 'vue';

import OssImg from './ossImg';
import Track from './track';

const globalDirectives = {
    // OssImg,
    Track,
};
Object.keys(globalDirectives).forEach(k => Vue.directive(k, globalDirectives[k]));

export {
    OssImg,
    Track,
};
